// import { Navigate, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux";

// // NOTE: Handle Protected Routes
// export const ProtectedReviewRoute = () => {
//   const { isAuthenticated, availableRoles } = useSelector(
//     (state) => state.auth
//   );

//   const role = availableRoles?.toLowerCase();

//   // Redirect to "/" if the user is not authenticated or does not have the appropriate role
//   if (!isAuthenticated || (role !== "staff" && role !== "family member")) {
//     return <Navigate to="/" replace />;
//   }

//   return <Outlet />;
// };

// // NOTE: Handle Public Routes
// export const PublicRoute = () => {
//   return <Outlet />;
// };

import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedReviewRoute = () => {
  const { isAuthenticated, availableRoles } = useSelector(
    (state) => state.auth
  );

  const role =
    typeof availableRoles === "string" ? availableRoles.toLowerCase() : "";

  if (!isAuthenticated || (role !== "staff" && role !== "family member")) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export const PublicRoute = () => {
  return <Outlet />;
};
